import { useTranslation } from 'react-i18next';

interface ErrorCodeTranslation {
  header: string;
  text: string;
}

function useErrorCodeTranslation() {
  const { t, i18n } = useTranslation();
  const genericErrorTexts = {
    header: t('errorCodes.generic.header'),
    text: t('errorCodes.generic.text')
  };
  return {
    translate: (
      error:
        | {
            payload: {
              errorCode: string;
            };
            code: number;
          }
        | string
    ): ErrorCodeTranslation => {
      let errorCode = null;
      if (typeof error === 'string') {
        errorCode = error;
      } else if (error?.payload?.errorCode) {
        errorCode = error.payload.errorCode;
      }

      if (errorCode) {
        let errorTranslationKey = `errorCodes.${errorCode}`;
        if (i18n.exists(errorTranslationKey)) {
          return {
            header: t(`${errorTranslationKey}.header`),
            text: t(`${errorTranslationKey}.text`)
          };
        } else {
          return {
            ...genericErrorTexts
          };
        }
      } else {
        return {
          header: t('errorCodes.generic.header'),
          text: t('errorCodes.generic.text')
        };
      }
    },
    genericErrorTexts: { ...genericErrorTexts }
  };
}

export default useErrorCodeTranslation;
